import {
  AppContextInfoContext,
  CookieConsentPrefs,
  getCookieConsentInfo,
  setCookieConsentInfo,
  useCookieConsent,
} from '@b2c/hooks';
import { CookieConsentModal, Footer, ServiceUnavailable } from '@b2c/ui';
import { AnalyticsHelper } from '@b2c/services/common';
import classNames from 'classnames';
import { useContext, useMemo } from 'react';
import { environment } from '../../environments/environment';
import { LayoutHeader } from './layout-header';
import styles from './layout.module.less';

export function Layout({ children, theme }) {
  const layoutModifier = useMemo(() => {
    return { white: styles.theme_white }[theme];
  }, [theme]);

  const unavailable = !!(useContext(AppContextInfoContext).appContext?.unavl);
  const { visible, closable, close } = useCookieConsent();

  function handleSavePrefs(prefs: CookieConsentPrefs) {
    const prevInfo = getCookieConsentInfo();
    setCookieConsentInfo(prefs);
    close();
    const trackingWasActive = prevInfo !== null && !prevInfo.expired && prevInfo.allowAnalyticsCookies;
    const trackingNowActive = prefs.allowAnalyticsCookies;
    if (trackingWasActive && !trackingNowActive) {
      location.reload();
    } else if (!trackingWasActive && trackingNowActive && !('gtag' in window)) {
      AnalyticsHelper.init(environment.analytics);
    }
  }

  const body = unavailable ? (
    <ServiceUnavailable siteName="HotelWhales" variant="split" />
  ) : (
    <>
      <div className={styles.layoutBody}>
        <div className={styles.layoutContainer}>
          <LayoutHeader />
          {children}
        </div>
      </div>
      <div className={styles.layoutFooter}>
        <div className={styles.layoutContainer}>
          <Footer brandName="HotelWhales" WebSiteName="HotelWhales.com" />
        </div>
      </div>
    </>
  );

  return (
    <div className={classNames(styles.layout, layoutModifier)}>
      {body}
      <CookieConsentModal
        open={visible}
        closable={closable}
        onClose={close}
        onSave={handleSavePrefs}
      />
    </div>
  );
}
